import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './dynamictable.module.scss';

export interface DynamicTableRow {
    rowLabel: ReactNode;
    items: ReactNode[];
}

interface DynamicTableProps {
    cornerLabelAriaText?: string;
    columnLabels: ReactNode[];
    rows: DynamicTableRow[];
}

export default function DynamicTable({ cornerLabelAriaText, rows, columnLabels }: DynamicTableProps): React.JSX.Element {
    return (
        <div role="table" className={cn('text-small', styles.table)}>
            <div role="row" className={styles.row}>
                <div role="columnheader" className={styles.cell}>
                    {cornerLabelAriaText && <div className="show-for-sr">{cornerLabelAriaText}</div>}
                </div>

                {columnLabels.map((columnLabel, index) => (
                    <div role="columnheader" className={cn(styles.label, styles.cell)} key={index}>
                        {columnLabel}
                    </div>
                ))}
            </div>

            {rows?.map(({ rowLabel, items }, index) => (
                <div role="row" className={styles.row} key={index}>
                    <div role="rowheader" className={cn(styles.label, styles.cell)}>
                        {rowLabel}
                    </div>

                    {items.map((item, index) => (
                        <div role="cell" className={cn('bold', styles.cell)} key={index}>
                            {item || <>&nbsp;</>}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
